import { useRef } from "react";

import { useVirtualizer } from "@tanstack/react-virtual";

import type { TabbedDropdownItemType } from "app/pages/sales-intelligence/types/types";

import type { DropdownVirtualListProps } from "./DropdownVirtualList";
import DropdownVirtualList from "./DropdownVirtualList";

type DropdownVirtualListContainerProps = {
    itemHeight: number;
    containerHeight: number;
    items: readonly TabbedDropdownItemType[];
} & Omit<DropdownVirtualListProps, "virtualizer">;

const DropdownVirtualListContainer = (props: DropdownVirtualListContainerProps) => {
    const { containerHeight, ...rest } = props;
    const containerRef = useRef<HTMLDivElement>(null);

    // oxlint-disable-next-line react/incompatible-library -- @tanstack/react-virtual's re-render model is incompatible with memoization; no compiler transform is enabled in this repo, so this is safe
    const rowVirtualizer = useVirtualizer({
        count: rest.items.length,
        getScrollElement: () => containerRef.current,
        estimateSize: () => rest.itemHeight,
    });

    return (
        <div
            style={{ height: containerHeight, overflow: "scroll" }}
            ref={containerRef}
        >
            <DropdownVirtualList
                {...rest}
                virtualizer={rowVirtualizer}
            />
        </div>
    );
};

export default DropdownVirtualListContainer;
